import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, role }) {

    const userRole = sessionStorage.getItem("role");

    // Not logged in
    if (!userRole) {
        return <Navigate to="/login" replace />;
    }

    if (role && role !== userRole) {
        return <Navigate to={`/${userRole}`} replace />;
    }

    return children;
}

export default ProtectedRoute;
